"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchBrandAttributes = exports.BRAND_CATEGORIES_ENDPOINT = exports.BRANDS_ENDPOINT = exports.initialNewBrandProductValue = exports.handleInitAttributeValue = exports.handleFormatAttributes = exports.translationNewBrandProduct = exports.translationBrandProductRequest = exports.handleCustomParamGridAjaxStore = exports.EVENT_CLICK_SHOW_MODAL_REQUEST_FORM = void 0;
const lodash_1 = require("lodash");
const utilities_1 = __importStar(require("jsAssets/utilities"));
const pulse_components_1 = require("@pcs/pulse-components");
const EVENT_CLICK_SHOW_MODAL_REQUEST_FORM = 'showModalRequestForm';
exports.EVENT_CLICK_SHOW_MODAL_REQUEST_FORM = EVENT_CLICK_SHOW_MODAL_REQUEST_FORM;
const BRANDS_ENDPOINT = `${utilities_1.URLS.app}api/brands/brand-access`;
exports.BRANDS_ENDPOINT = BRANDS_ENDPOINT;
const BRAND_CATEGORIES_ENDPOINT = `${utilities_1.URLS.app}api/brand-categories/brand-access`;
exports.BRAND_CATEGORIES_ENDPOINT = BRAND_CATEGORIES_ENDPOINT;
const BRAND_ATTRIBUTES_ENDPOINT = `${utilities_1.URLS.app}api/brand-attributes/brand-access`;
const translationBrandProductRequest = {
    brand: 'Brand',
    product: 'product',
    requestForm: 'RequestForm',
    brandCategory: 'BrandCategory',
    requestAccess: 'RequestAccess',
    requestNewBrand: 'RequestNewBrand',
    search: 'Search',
    brandProductWarningMessage: 'BrandProductWarningMessage',
    accessRequest: 'AccessRequest',
    requestingAgency: 'RequestingAgency',
    reasonForAccessToBrand: 'ReasonForAccessToBrand',
    submitAccessRequest: 'SubmitAccessRequest',
    enterReasonForAccessToBrand: 'EnterReasonForAccessToBrand',
    success: 'Success',
    youHaveSuccessfullyRequestedAccessToTheExisting: 'YouHaveSuccessfullyRequestedAccessToTheExisting',
    theApproverHasBeenNotified: 'TheApproverHasBeenNotified',
    close: 'Close',
    required: 'Required',
    enterBrandOrProduct: 'EnterBrandOrProduct',
    productName: 'ProductName',
    youHaveSuccessfullyRequestedAccessToANew: 'YouHaveSuccessfullyRequestedAccessToANew',
};
exports.translationBrandProductRequest = translationBrandProductRequest;
const translationNewBrandProduct = {
    agencyRequestor: 'AgencyRequestor',
    brandCategory: 'BrandCategory',
    brand: 'Brand',
    product: 'Product',
    requestorComment: 'RequestorComment',
    requestNewBrandProductForSystem: 'RequestNewBrandProductForSystem',
    requestNewBrand: 'RequestNewBrand',
    brandCategoryAttributes: 'BrandCategoryAttributes',
    brandAttributes: 'BrandAttributes',
    selectBrandCategory: 'SelectBrandCategory',
    selectBrand: 'SelectBrand',
    selectAgencyRequestor: 'SelectAgencyRequestor',
    new: 'New',
    productName: 'ProductName',
    website: 'Website',
    attachments: 'Attachments',
};
exports.translationNewBrandProduct = translationNewBrandProduct;
const handleCustomParamGridAjaxStore = (gridAjaxStore, filterKey, filterValue, isLoadPage = true, page = 1) => {
    const currentParams = gridAjaxStore.params;
    if (filterValue !== currentParams[filterKey]) {
        const searchParam = {};
        searchParam[filterKey] = filterValue;
        const newConfig = Object.assign(currentParams, searchParam);
        gridAjaxStore.setConfig(newConfig);
        if (isLoadPage) {
            gridAjaxStore.loadPage(page, newConfig);
        }
    }
};
exports.handleCustomParamGridAjaxStore = handleCustomParamGridAjaxStore;
const handleFormatAttributes = (AttributeOptions) => {
    return (0, lodash_1.values)((0, lodash_1.mapValues)((0, lodash_1.groupBy)(AttributeOptions, 'brand-attribute.id'), (options) => {
        var _a, _b, _c, _d;
        return {
            brandAttribute: ((_a = options[0]) === null || _a === void 0 ? void 0 : _a['brand-attribute'])
                ? {
                    id: (_b = options[0]) === null || _b === void 0 ? void 0 : _b['brand-attribute'].id,
                    value: (_c = options[0]) === null || _c === void 0 ? void 0 : _c['brand-attribute'].name,
                    isMandatory: (_d = options[0]) === null || _d === void 0 ? void 0 : _d['brand-attribute'].is_mandatory,
                }
                : null,
            brandAttributeOptions: options.map((brandAtt) => ({
                value: brandAtt === null || brandAtt === void 0 ? void 0 : brandAtt.id,
                label: brandAtt === null || brandAtt === void 0 ? void 0 : brandAtt.value,
            })),
        };
    }));
};
exports.handleFormatAttributes = handleFormatAttributes;
const handleInitAttributeValue = (attributesOption, typeAttribute, isFormat = true) => {
    if (attributesOption) {
        const convertAttribute = isFormat
            ? handleFormatAttributes(attributesOption)
            : attributesOption;
        const attributesOptions = convertAttribute
            .filter((item) => {
            var _a;
            return (_a = item.brandAttribute) === null || _a === void 0 ? void 0 : _a.isMandatory;
        })
            .map((item) => {
            var _a, _b;
            const uniqueAttrKey = `${typeAttribute}${(_a = item.brandAttribute) === null || _a === void 0 ? void 0 : _a.id}`;
            const brandCategoryOptionValues = ((_b = item.brandAttributeOptions) === null || _b === void 0 ? void 0 : _b.length) === 1
                ? {
                    label: item.brandAttributeOptions[0].label,
                    value: item.brandAttributeOptions[0].value,
                }
                : null;
            const transformedAttributes = {};
            transformedAttributes[uniqueAttrKey] = brandCategoryOptionValues;
            return transformedAttributes;
        });
        const resultValue = attributesOptions.reduce((acc, value) => {
            return { ...acc, ...value };
        }, {});
        return resultValue;
    }
};
exports.handleInitAttributeValue = handleInitAttributeValue;
const initialNewBrandProductValue = {
    agencyRequestor: {
        value: utilities_1.PRIMARY_OFFICE_ID,
        label: utilities_1.PRIMARY_OFFICE_NAME,
    },
    requestorComment: '',
    product: '',
    brand: null,
    brandCategory: null,
    brandAttributes: null,
    brandCatAttributes: null,
    brandAttributeOptions: null,
    brandCatAttributeOptions: null,
    website: '',
    attachments: [],
};
exports.initialNewBrandProductValue = initialNewBrandProductValue;
/**
 * Formats an array of brand attributes and their associated options.
 *
 * @param data - An array of TJsonaModel objects representing brand attributes.
 * @returns FormatBrandAttributes[] - An array of formatted brand attributes and their options.
 */
const formatBrandAttributes = (data) => {
    return data.map((item) => {
        // Format brand attribute object
        const brandAttribute = {
            id: item.id,
            isMandatory: item.is_mandatory,
            value: item.name,
        };
        // Filter and format brand-attribute-options where restrict_to_brand = true
        const brandAttributeOptions = item['brand-attribute-options']
            .filter((option) => option.restrict_to_brand === true)
            .map((option) => ({
            label: option.value,
            value: option.id,
        }));
        const uniqueBrandAttributeOptions = new Map();
        brandAttributeOptions.forEach((brandAtt) => {
            uniqueBrandAttributeOptions.set(brandAtt.label, brandAtt);
        });
        return {
            brandAttribute,
            brandAttributeOptions: Array.from(uniqueBrandAttributeOptions.values()),
        };
    });
};
/**
 * Fetches brand attributes based on the provided brand category ID.
 *
 * @param brandCategoryId - The ID of the brand category to fetch attributes for.
 * @returns Promise<FormatBrandAttributes[] | null> - A promise that resolves to an array of formatted brand attributes or null if an error occurs.
 */
const fetchBrandAttributes = async (brandCategoryId) => {
    try {
        utilities_1.default.blockPage('Fetching brand attributes, please wait...');
        const response = await (0, pulse_components_1.v2Endpoint)({
            method: pulse_components_1.METHODS.GET,
            url: BRAND_ATTRIBUTES_ENDPOINT,
            params: {
                'filter[use_new_brand_request]': 1,
                'filter[brand-category-id]': brandCategoryId,
                include: 'brand-attribute-options',
            },
        });
        return formatBrandAttributes((0, utilities_1.parseJsonApi)(response.data));
    }
    catch (error) {
        utilities_1.default.notification.danger(error);
        return null;
    }
    finally {
        utilities_1.default.unblockPage();
    }
};
exports.fetchBrandAttributes = fetchBrandAttributes;
